__turbopack_context__.v({
  "desktopOnly": "filterSort-module-scss-module__Kk0iLG__desktopOnly",
  "filterCheckboxes": "filterSort-module-scss-module__Kk0iLG__filterCheckboxes",
  "filterSortContainer": "filterSort-module-scss-module__Kk0iLG__filterSortContainer",
  "mobileOnly": "filterSort-module-scss-module__Kk0iLG__mobileOnly",
  "selectedSortTag": "filterSort-module-scss-module__Kk0iLG__selectedSortTag",
  "sortFilterText": "filterSort-module-scss-module__Kk0iLG__sortFilterText",
  "sortOptions": "filterSort-module-scss-module__Kk0iLG__sortOptions",
  "sortSelect": "filterSort-module-scss-module__Kk0iLG__sortSelect",
  "tag": "filterSort-module-scss-module__Kk0iLG__tag",
});
